/* Footer: Linkspalten mobil als Akkordeon, ab Tablet offen. Cookie-Einstellungen über die Shopify-Banner-API. */

class KgFooter extends HTMLElement {
  connectedCallback() {
    this.groups = [...this.querySelectorAll('details.footer__group')];
    this.columns = window.matchMedia('(min-width: 750px)');
    this.apply = () => {
      this.groups.forEach((group) => {
        group.open = this.columns.matches;
      });
    };
    this.columns.addEventListener('change', this.apply);
    this.apply();

    this.querySelectorAll('[data-privacy-preferences]').forEach((button) => {
      button.addEventListener('click', () => {
        /* Erst das eigene Banner fragen, sonst das von Shopify */
        if (document.querySelector('kg-cookie-banner')) {
          document.dispatchEvent(new CustomEvent('kg:privacy-open'));
          return;
        }
        window.privacyBanner?.showPreferences?.();
      });
    });
  }

  disconnectedCallback() {
    this.columns.removeEventListener('change', this.apply);
  }
}

customElements.define('kg-footer', KgFooter);
